// extracted by mini-css-extract-plugin
export var modalFooter = "_pg-0";